// extracted by mini-css-extract-plugin
export default {"root":"TeI95sJ7bCgxgsGAmlpJ","item":"AfJdk7UPVGrz2rotkpYY","title":"p2HzmN47VTZfpFBnmBIz","content":"HtX8p94xSZe6KsP8lYw2"};